import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';
import { ErrorDialogModel } from './generic-dialogs.model';

@Component({
	template: `
		<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
			<h1 mat-dialog-title cdkDragHandle>{{ title }}</h1>
		</div>

		@if (ready$ | async) {
			<div id="dialog-content" mat-dialog-content>
				<div class="content">
					<div class="message">
						{{ message }}
					</div>
				</div>
			</div>
		}

		<div mat-dialog-actions align="end">
			<button (click)="onClose()" mat-stroked-button color="primary">Close</button>
		</div>
	`,
	styles: [
		`
			:host {
				display: grid;
				grid-template-rows: auto 1fr auto;
				height: 100%;

				h2 {
					margin: 4px 0;
				}

				#dialog-content {
					display: grid;
					grid-template-rows: 1fr;
					max-height: 80vh;
					margin-top: 0;
				}

				div.content {
					display: grid;
					grid-template-rows: auto 1fr;
					overflow: auto;
				}
			}
		`,
	],
	imports: [CommonModule, DragDropModule, MatButtonModule, MatCheckboxModule, MatDialogModule],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServerErrorDialogComponent implements AfterViewInit {
	title: string;
	message: string;
	allowShowErrorDetails = false;
	showErrorDetails?: boolean;

	ready$ = new BehaviorSubject(false);

	constructor(
		public dialogRef: MatDialogRef<ServerErrorDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: ErrorDialogModel,
		private cdRef: ChangeDetectorRef,
	) {
		// Update view with given values
		this.title = data.title;
		this.message = data.message;
	}

	ngAfterViewInit() {
		setTimeout(() => {
			this.ready$.next(true);
			this.cdRef.detectChanges();
		});
	}

	onClose(): void {
		this.dialogRef.close();
	}
}
